import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/commands/setheadercolumncommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { findAncestor, updateNumericAttribute } from "./utils";
/**
 * The header column command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as `'setTableColumnHeader'` editor command.
 *
 * You can make the column containing the selected cell a [header](https://www.w3.org/TR/html50/tabular-data.html#the-th-element)
 * by executing:
 *
 *		editor.execute( 'setTableColumnHeader' );
 *
 * **Note:** All preceding columns will also become headers. If the current column is already a header, executing this command
 * will make it a regular column back again (including the following columns).
 *
 * @extends module:core/command~Command
 */

var SetHeaderColumnCommand = /*#__PURE__*/function (_Command) {
  _inherits(SetHeaderColumnCommand, _Command);

  var _super = _createSuper(SetHeaderColumnCommand);

  function SetHeaderColumnCommand() {
    _classCallCheck(this, SetHeaderColumnCommand);

    return _super.apply(this, arguments);
  }

  _createClass(SetHeaderColumnCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      var selection = doc.selection;
      var position = selection.getFirstPosition();
      var tableCell = findAncestor('tableCell', position);
      var isInTable = !!tableCell;
      this.isEnabled = isInTable;
      /**
       * Flag indicating whether the command is active. The command is active when the
       * {@link module:engine/model/selection~Selection} is in a header column.
       *
       * @observable
       * @readonly
       * @member {Boolean} #value
       */

      this.value = isInTable && this._isInHeading(tableCell, tableCell.parent.parent);
    }
    /**
     * Executes the command.
     *
     * When the selection is in a non-header column, the command will set the `headingColumns` table attribute to cover that column.
     *
     * When the selection is already in a header column, it will set `headingColumns` so the heading section will end before that column.
     *
     * @fires execute
     * @param {Object} [options]
     * @param {Boolean} [options.forceValue] If set, the command will set (`true`) or unset (`false`) header columns according to
     * `forceValue` parameter instead of the current model state.
     */

  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var doc = model.document;
      var selection = doc.selection;
      var tableUtils = this.editor.plugins.get('TableUtils');
      var position = selection.getFirstPosition();
      var tableCell = findAncestor('tableCell', position);
      var tableRow = tableCell.parent;
      var table = tableRow.parent;

      var _tableUtils$getCellLo = tableUtils.getCellLocation(tableCell),
          selectionColumn = _tableUtils$getCellLo.column;

      if (options.forceValue === this.value) {
        return;
      }

      var headingColumnsToSet = this.value ? selectionColumn : selectionColumn + 1;
      model.change(function (writer) {
        updateNumericAttribute('headingColumns', headingColumnsToSet, table, writer, 0);
      });
    }
    /**
     * Checks if a table cell is in the heading section.
     *
     * @param {module:engine/model/element~Element} tableCell
     * @param {module:engine/model/element~Element} table
     * @returns {Boolean}
     * @private
     */

  }, {
    key: "_isInHeading",
    value: function _isInHeading(tableCell, table) {
      var headingColumns = parseInt(table.getAttribute('headingColumns') || 0);
      var tableUtils = this.editor.plugins.get('TableUtils');

      var _tableUtils$getCellLo2 = tableUtils.getCellLocation(tableCell),
          column = _tableUtils$getCellLo2.column;

      return !!headingColumns && column < headingColumns;
    }
  }]);

  return SetHeaderColumnCommand;
}(Command);

export { SetHeaderColumnCommand as default };